import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {map} from "rxjs/operators";

@Injectable()
export class UsersService {
  constructor(private http: HttpClient) {}

  users() {
    return this.http.get('/users');
  }
  getCurrentUser() {
    return this.http.get('/users/current-dto').pipe((map((value: any) => [value])));
  }

  stats() {
    return this.http.get('/users/stats');
  }
}
